import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleParagraph1 } from '@cian/ui-kit';

import { PageDescription } from '../../components/PageDescription';
import { selectPageSeo } from '../../selectors/seo';

interface IPageDescriptionContainerProps {
  isCompilation: boolean;
}

export const PageDescriptionContainer: React.FC<IPageDescriptionContainerProps> = ({ isCompilation }) => {
  const { pageDescription } = useSelector(selectPageSeo);

  if (!pageDescription) {
    return null;
  }

  if (isCompilation) {
    return (
      <ArticleParagraph1 as="p" color="text-primary-default">
        {pageDescription}
      </ArticleParagraph1>
    );
  }

  return <PageDescription>{pageDescription}</PageDescription>;
};
